import $ from 'jquery'

$(document).on('click', '.js-print-this', function () {
  let target = $(this).data('target') || this
  $(target).printThis({
    removeScripts: true
  })
})
